import React, {useEffect, useState} from 'react';
import {UseFormReturn, useWatch} from "react-hook-form";
import CardActions from "../../../components/CardActions";
import {Grid, TextField as MUITextField, Typography} from "@mui/material";
import {
  EntityWithIdAndDescriptionFields,
  EntityWithIdFields,
  Moneda,
  SectorComercial,
  SectorComercialFields
} from "../../../../../types";
import {ControlledDatePicker, ControlledTextField} from "../../../../../components/forms";
import {FormOperacionNotaEstructurada, OperacionNotaEstructurada} from "../types/types";
import {dateFormatter} from "../../../../../utils/formatters";
import {OperacionNotaEstructuradaFields} from "../types/fields";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import {HttpCacheGeneral} from "../../../../../http/httpCacheGeneral";
import {TextField} from "src/lib/itaptec/components_forms/src";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {useSectoresComerciales} from "../../../../messages/api/useSectoresComerciales";

type DatosOperacionProps = {
  formMethods: UseFormReturn<FormOperacionNotaEstructurada>
  readOnly?: boolean
  operacion?: OperacionNotaEstructurada
  codSistemaPrincipal: number
  codSistema: number
  nuevo?: boolean
}

function SeccionNotaEstructuradaDatosOperacion({
                                                 formMethods,
                                                 readOnly,
                                                 operacion,
                                                 codSistemaPrincipal,
                                                 codSistema,
                                                 nuevo
                                               }: DatosOperacionProps) {

  const [monedas, setMonedas] = useState<Moneda[]>([])

  const {control, reset, getValues, setValue, watch, formState: {errors}} = formMethods
  const watchSectorComercial = useWatch({control, name: OperacionNotaEstructuradaFields.CodSectorComercial})

  const {sectores, loading, isError, error} = useSectoresComerciales(codSistema)

  useEffect(() => {
    HttpCacheGeneral.getMonedas().then((monedas: Moneda[]) => {
      setMonedas(monedas)
    })
  }, [])

  useEffect(() => {
    if (sectores.length > 0) {
      setValue(OperacionNotaEstructuradaFields.CodSectorComercial, sectores[0]?.[SectorComercialFields.SectorComercialCodigo])
    }
  }, [sectores, reset, setValue, getValues])

  return (
    <CardActions title='Datos Operación' colapsable>
      <Grid container spacing={4}>
        {
          !nuevo &&
            <Grid item xs={12} md={3}>
                <Typography variant='body2'>Usuario Alta</Typography>
                <Typography>{`${operacion?.nombreUsuarioAlta} ${operacion?.apellidoUsuarioAlta}`}</Typography>
            </Grid>
        }
        <Grid item xs={12} md={3}>
            {/*<h1>{console.log(JSON.stringify(watchSectorComercial)}</h1>*/}
          {
            readOnly ?
              <>
                <Typography variant='body2'>Fecha Aprobación</Typography>
                <Typography>{dateFormatter.toShortDate(operacion?.[OperacionNotaEstructuradaFields.FechaAprobacion] || '')}</Typography>
              </> :
              <ControlledDatePicker
                name={OperacionNotaEstructuradaFields.FechaAprobacion}
                label='Fecha Aprobación'
                control={control}
                selectedSections={undefined}
                onSelectedSectionsChange={console.log}
                fullWidth
                readOnly={readOnly}
              />
          }
        </Grid>
        <Grid item xs={12} md={3}>
          {
            readOnly ?
              <>
                <Typography variant='body2'>Fecha Vencimiento</Typography>
                <Typography>{(operacion && operacion?.fechaVencimiento) ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : '-'}</Typography>
              </> :
              <ControlledDatePicker
                name={OperacionNotaEstructuradaFields.FechaVencimiento}
                label='Fecha Vencimiento'
                control={control}
                selectedSections={undefined}
                onSelectedSectionsChange={console.log}
                fullWidth
                minDate={watch(OperacionNotaEstructuradaFields.FechaAprobacion)}
                readOnly={readOnly}
              />
          }
        </Grid>

        <Grid item xs={12} md={4}>
          {
            readOnly ?
              <>
                <Typography variant='body2'>Sector Comercial</Typography>
                <Typography>{operacion?.nombreSectorComercial}</Typography>
              </> :
              <>
                <MUITextField
                  label='Sector Comercial'
                  value={sectores.find((sector) => sector[SectorComercialFields.SectorComercialCodigo] === watchSectorComercial)?.[EntityWithIdAndDescriptionFields.Description] || ''}
                  size={'small'}
                  error={!!errors[OperacionNotaEstructuradaFields.CodSectorComercial]}
                  helperText={errors[OperacionNotaEstructuradaFields.CodSectorComercial]?.message}
                  disabled
                />
              </>
          }
        </Grid>

      </Grid>
    </CardActions>
  );
}

export default SeccionNotaEstructuradaDatosOperacion;